export default {
  breakpoints: ['40em', '56em', '64em'],
  colors: {
    text : '#232323',
    background: '#fff',
    textDark: '#ffffff',
    backgroundDark: '#0065B2',
    primary: '#E65447',
    base: "#E65447",
    "black": "#473c3b",
    "gray": [
      "#faf9f8",
      "#f0ecec",
      "#e5dfde",
      "#dad0cf",
      "#cdc0bf",
      "#bfafad",
      "#af9b98",
      "#9a8381",
      "#796865",
      "#473c3b"
    ],
    "red": [
      "#fceceb",
      "#f9d8d6",
      "#f6c1bd",
      "#f2a6a0",
      "#ed847c",
      "#e65247",
      "#cf4a40",
      "#b54038",
      "#96352e",
      "#6b2621"
    ],
    "orange": [
      "#fbf2e7",
      "#f8e5cd",
      "#f4d7b1",
      "#f0c792",
      "#ebb56f",
      "#e6a147",
      "#cf9140",
      "#b67f38",
      "#97692e",
      "#6c4c21"
    ],
    "yellow": [
      "#fafbe5",
      "#f4f7ca",
      "#eff3ad",
      "#e8ef8e",
      "#e2eb6c",
      "#dbe647",
      "#c6d040",
      "#aeb738",
      "#91982f",
      "#696e22"
    ],
    "lime": [
      "#f0fbe7",
      "#dff8cd",
      "#cef4b1",
      "#baf092",
      "#a5eb6f",
      "#8ce647",
      "#7ed040",
      "#6fb738",
      "#5c982e",
      "#436e22"
    ],
    "green": [
      "#e9fcea",
      "#d2f8d4",
      "#b7f5bb",
      "#99f19f",
      "#75ec7d",
      "#47e652",
      "#40d04a",
      "#38b741",
      "#2f9836",
      "#226e27"
    ],
    "teal": [
      "#e8fbf3",
      "#d0f8e7",
      "#b5f5d9",
      "#97f0c9",
      "#73ebb7",
      "#47e6a1",
      "#40d091",
      "#38b780",
      "#2f986a",
      "#226e4d"
    ],
    "cyan": [
      "#e8fafb",
      "#cff5f8",
      "#b4f0f4",
      "#95eaf0",
      "#71e3eb",
      "#47dbe6",
      "#40c6d0",
      "#38aeb6",
      "#2e9098",
      "#21686e"
    ],
    "blue": [
      "#e9f1fc",
      "#d1e2f8",
      "#b7d2f5",
      "#99bff1",
      "#75a8ec",
      "#478ce6",
      "#407ecf",
      "#386eb5",
      "#2e5b95",
      "#20416a"
    ],
    "indigo": [
      "#edecfc",
      "#d9d7f9",
      "#c3bff6",
      "#a9a3f2",
      "#877fed",
      "#5247e6",
      "#493fcf",
      "#4037b4",
      "#342d93",
      "#241f67"
    ],
    indigoOverlay: [
      "#edecfcaa"
    ],
    "violet": [
      "#f5ebfc",
      "#ead6f9",
      "#ddbdf6",
      "#cfa1f2",
      "#bc7ced",
      "#a147e6",
      "#9140cf",
      "#7e37b5",
      "#682e95",
      "#4a2069"
    ],
    "fuschia": [
      "#fcebfb",
      "#f9d6f7",
      "#f6bef2",
      "#f2a2ec",
      "#ed7de5",
      "#e647db",
      "#cf40c5",
      "#b638ad",
      "#962e8f",
      "#6c2167"
    ],
    "pink": [
      "#fcebf3",
      "#f9d6e5",
      "#f6bed6",
      "#f2a2c4",
      "#ed7dae",
      "#e6478c",
      "#cf407e",
      "#b5386e",
      "#962e5b",
      "#6b2141"
    ]
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  sizes: {
    container: 640,
    sidebar : 320,
    modal: 250
  },
  buttons: {
    primary:{
      bg:'base',
      color:'textDark'
    },
    neutral:{
      bg:'gray.1',
      color:'gray.8',
      px: 4,
      py: 2,
      marginRight: 2,
      border: 'none'
    }
  }
}